import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import { useWaitingOrder } from "./WaitingOrderContext";

const SocketContext = createContext();

export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const dataStorage = localStorage.getItem("user");
  const parsedDataStorage = dataStorage && JSON.parse(dataStorage);
  const token = parsedDataStorage?.token;
  const [socket, setSocket] = useState(null);
  const [roomData, setRoomData] = useState(null);
  const SOCKET_SERVER_URL = `${process.env.REACT_APP_SOCKET_SERVER_URL}?token=${token}`;
  const channelId = "AdminRoom321";

  const { updateIsWaitingOrder, updateInProgressOrderId, inProgressOrderId } =
    useWaitingOrder();

  useEffect(() => {
    const newSocket = io(SOCKET_SERVER_URL);
    setSocket(newSocket);
    newSocket.on("connect", () => {
      newSocket.on("onReceiveLocation", (data) => {
        setRoomData(data);
      });
      newSocket.on("receiveAcceptJob", (data) => {
        const parsedData = JSON.parse(data);
        if (inProgressOrderId === parsedData.order_id) {
          localStorage.setItem("isWaitingOrder", "false");
          localStorage.setItem("inProgress_orderId", null);
          updateIsWaitingOrder(false);
          updateInProgressOrderId(null);
          toast.success(
            `The driver ${parsedData.driver_first_name} ${parsedData.driver_last_name} has accepted your order.`
          );
        }
      });
    });
  }, [channelId, inProgressOrderId]);

  // Function to send data to the specified channel
  const sendToChannel = (final_body) => {
    if (!socket) {
      console.error("Socket is not connected");
      return;
    }
    socket
      .emitWithAck("search", final_body)
      .then((response) => {
        if (response.status === "cancel") {
          localStorage.setItem("isWaitingOrder", "false");
          updateInProgressOrderId(null);
          updateIsWaitingOrder("false");
          localStorage.setItem("inProgress_orderId", null);

          toast.error(`No Driver Found`);
        }
      })
      .catch((error) => {
        console.error("Error from server: ", error);
      });
  };

  return (
    <SocketContext.Provider value={{ socket, roomData, sendToChannel }}>
      {children}
    </SocketContext.Provider>
  );
};
